import { fetchWithAuth } from './auth';
import type { InspectionRouteEstimate } from './routeEstimate';

export interface FieldTodayRouteAppraisal {
  id: string;
  policyholder_name: string | null;
  claim_number: string | null;
  status: string | null;
  property_address: string | null;
  address_street: string | null;
  address_city: string | null;
  address_state: string | null;
  address_zip: string | null;
}

export interface FieldTodayRouteInspection {
  id: string;
  date: string;
  status: string | null;
  type: string | null;
  inspector: string | null;
  duration_minutes: number | null;
  notes: string | null;
}

export interface FieldTodayRouteItem {
  appraisal: FieldTodayRouteAppraisal;
  inspection: FieldTodayRouteInspection;
  route_estimate: InspectionRouteEstimate | null;
}

export interface FieldTodayRouteResponse {
  date: string;
  timezone: string;
  items: FieldTodayRouteItem[];
  next_item: FieldTodayRouteItem | null;
}

export async function getTodayRoute(targetDate?: string): Promise<FieldTodayRouteResponse> {
  const qs = targetDate ? `?target_date=${encodeURIComponent(targetDate)}` : '';
  const r = await fetchWithAuth(`/api/field/today-route${qs}`);
  if (!r.ok) throw new Error(`getTodayRoute failed: ${r.status}`);
  return (await r.json()) as FieldTodayRouteResponse;
}
